import { NgModule } from '@angular/core';
import { CloseDetailsGuard } from '@bci-web-core/core';
import { Routes, RouterModule } from '@angular/router';
import { AppGuard } from './app.guard';
import { AddBuildingComponent } from './Components/add/add-building/add-building/add-building.component';
import { LoginComponent } from './Components/user/login.component';
import { HomeComponent } from './Components/home/home.component';
// Site
import {
  SiteMasterComponent, SiteDetailComponent,
  SetupProjectComponent, SiteCreationComponent,
  ConnectionDetailsComponent, ShiftDetailsComponent, WidgetConfigurationComponent,
  ReportConfigurationComponent, DataAcquisitionLayoutComponent, TreeConfigurationComponent,
  ClickAndNavigationDetailsComponent
} from './Components/site/site-master/index';
import { OverViewComponent } from './Components/site/over-view/over-view.component';
import { UtilitiesComponent } from './Components/site/utilities/utilities.component';
import { MachineMonitoringComponent } from './Components/site/machine-monitoring/machine-monitoring.component';
import { KpiBenchmarkingComponent } from './Components/site/kpi-benchmarking/kpi-benchmarking.component';
// Energy Dashboard
import {
  EnergyDashboardComponent, EnergyComponent, LoadOnTreeComponent, TestbenchOverviewComponent,
  RealTimeComponent, SpecificEnergyComponent, MeterViewComponent,
  TransformerMonitoringComponent, TransformerDashboardComponent, DeepDiveComponent,
  NotificationsComponent as NotificationsOnEngergyComponent, EnergyTrendsComponent
} from './Components/site/energy-dashboard/index';
// Solar Dashboard
import { SolarDashboardComponent } from './Components/site/solar-dashboard/solar-dashboard.component';
import { PlantOverviewComponent } from './Components/site/solar-dashboard/plant-overview/plant-overview.component';
import { InverterViewComponent } from './Components/site/solar-dashboard/inverter-view/inverter-view.component';
import { ArchitectureComponent } from './Components/site/solar-dashboard/architecture/architecture.component';
import { NotificationsComponent } from './Components/site/solar-dashboard/notifications/notifications.component';
// tslint:disable-next-line:max-line-length
import { SolarLongTermTrendComponent } from './Components/site/solar-dashboard/plant-overview/solar-long-term-trend/solar-long-term-trend.component';
import { SolarDailyReportComponent } from './Components/report/solar-daily-report/solar-daily-report.component';
import { SolarMonthlyReportComponent } from './Components/report/solar-monthly-report/solar-monthly-report.component';
import { ProcessAndLoadDetailsComponent } from './Components/site/site-master/process-and-load-details/process-and-load-details.component';
import { EnergyTreeExcelComponent } from './Components/report/energy-tree-excel/energy-tree-excel.component';
// Add
import { AddNodeComponent } from './Components/add/add-node/add-node.component';
import { AddDcuComponent } from './Components/add/add-dcu/add-dcu.component';
import { AddUserComponent } from './Components/add/add-user/add-user.component';
import { AddMeterComponent } from './Components/add/add-meter/add-meter.component';
import { AddLoadComponent } from './Components/add/add-load/add-load.component';
// Role-Management
import { RoleManagementComponent } from './Components/role-management/role-management.component';
import { UserManagementComponent } from './Components/user/user-management/user-management.component';
import { PlantNavigationComponent } from './Components/site/over-view/plant-navigation/plant-navigation.component';
import { AdalGuard } from 'adal-angular4';
import { MeterInventoryComponent } from './Components/view/meter-inventory/meter-inventory.component';
import { LoadInventoryComponent } from './Components/view/load-inventory/load-inventory.component';
import { DcuInventoryComponent } from './Components/view/dcu-inventory/dcu-inventory.component';
import { ManageReportComponent } from './Components/report/manage-report/manage-report.component';
import { ManageSolarSchedulerComponent } from './Components/report/manage-solar-scheduler/manage-solar-scheduler.component';
import { HelpComponent } from './Components/help/help.component';
import { EqBenchmarkingComponent } from './Components/report/eq-benchmarking/eq-benchmarking.component';
//Export
import { RealtimeDataComponent } from './Components/export/realtime-data/realtime-data.component';
import { UtilityConsumptionChartsComponent } from './Components/site/over-view/utility-consumptionCharts/utility-consumption-charts/utility-consumption-charts.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'user-management', component: UserManagementComponent },
  { path: 'add-user', component: AddUserComponent },
  { path: 'add-node', component: AddNodeComponent },
  { path: 'add-dcu', component: AddDcuComponent },
  { path: 'add-meter', component: AddMeterComponent },
  { path: 'add-load', component: AddLoadComponent },
  { path: 'add-load/:loadId/:siteId', component: AddLoadComponent },
  { path: 'add-building', component: AddBuildingComponent },
  { path: 'role-management', component: RoleManagementComponent },
  { path: 'meter-inventory', component: MeterInventoryComponent },
  { path: 'load-inventory', component: LoadInventoryComponent },
  { path: 'dcu-inventory', component: DcuInventoryComponent },
  {
    path: 'site-master', component: SiteMasterComponent,
    children: [
      {
        path: ':id',
        component: SiteDetailComponent,
        canDeactivate: [CloseDetailsGuard]
      }]
  },
  { path: 'setup-project', component: SetupProjectComponent },
  {
    path: 'site', component: HomeComponent,
    children: [
      {
        path: 'over-view',
        component: OverViewComponent,
      },
      {
        path: 'energy-dashboard', component: EnergyDashboardComponent,
        children: [
          {
            path: 'energy',
            component: EnergyComponent,
          },
          {
            path: 'load-on-tree',
            component: LoadOnTreeComponent,
          },
          {
            path: 'testbench-overview',
            component: TestbenchOverviewComponent,
          },
          {
            path: 'real-time',
            component: RealTimeComponent,
          },
          {
            path: 'specific-energy',
            component: SpecificEnergyComponent,
          },
          {
            path: 'meter-view',
            component: MeterViewComponent,
          },
          {
            path: 'transformer-monitoring',
            component: TransformerMonitoringComponent,
          },
          {
            path: 'transformer-dashboard',
            component: TransformerDashboardComponent,
          },
          {
            path: 'deep-dive',
            component: DeepDiveComponent,
          },
          {
            path: 'notifications',
            component: NotificationsOnEngergyComponent,
          }
        ]
      },
      { path: 'utilities', component: UtilitiesComponent },
      {
        path: 'solar-dashboard', component: SolarDashboardComponent,
        children: [
          {
            path: 'plant-view',
            component: PlantOverviewComponent,
          },
          {
            path: 'inverter-view',
            component: InverterViewComponent,
          },
          {
            path: 'architecture',
            component: ArchitectureComponent,
          },
          {
            path: 'notification',
            component: NotificationsComponent,
          }
        ]
      },
      { path: 'machine-monitoring', component: MachineMonitoringComponent },
      { path: 'kpi-benchmarking', component: KpiBenchmarkingComponent },
      {
        path: 'solar-daily', component: SolarDailyReportComponent
      },
      {
        path: 'plant-navigation', component: PlantNavigationComponent
      }
    ]
  },
  {
    path: 'multi-step-form', component: SetupProjectComponent,
    children: [
      { path: 'site-creation', component: SiteCreationComponent },
      { path: 'connection-details', component: ConnectionDetailsComponent },
      { path: 'shift-details', component: ShiftDetailsComponent },
      { path: 'process-and-load-details', component: ProcessAndLoadDetailsComponent },
      { path: 'widget-configuration', component: WidgetConfigurationComponent },
      { path: 'report-configuration', component: ReportConfigurationComponent },
      { path: 'data-acquisition-layout', component: DataAcquisitionLayoutComponent },
      { path: 'tree-configuration', component: TreeConfigurationComponent },
      { path: 'click-and-navigation-details', component: ClickAndNavigationDetailsComponent }
    ]
  },
  {
    path: 'solar-long-term-trend',
    component: SolarLongTermTrendComponent,
  },
  {
    path: 'utility-consumptionCharts',
    component: UtilityConsumptionChartsComponent
  },
  {
    path: 'energy-long-term-trend',
    component: EnergyTrendsComponent,
  },
  { path: 'solar-daily/:type', component: SolarDailyReportComponent, canActivate: [AppGuard] },
  { path: 'solar-monthly/:type', component: SolarMonthlyReportComponent, canActivate: [AppGuard] },
  { path: 'energy-tree-excel', component: EnergyTreeExcelComponent, canActivate: [AppGuard] },
  { path: 'manage-report', component: ManageReportComponent, canActivate: [AppGuard] },
  { path: 'manage-solar-scheduler', component: ManageSolarSchedulerComponent, canActivate: [AppGuard] },
  { path: 'help', component: HelpComponent , canActivate: [AppGuard]},
  { path: 'sub-item-1', component: EqBenchmarkingComponent , canActivate: [AppGuard]},
    //Export
    { path: 'realtime-data', component: RealtimeDataComponent , canActivate: [AppGuard]},

];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [CloseDetailsGuard]
})
export class AppRoutingModule { }
